import { isUndefined } from 'lodash-es';

import { HoneycombDownloadDataButton } from './buttons/HoneycombDownloadDataButton.js';
import { useBehavioralTrackingProps as _useBehavioralTrackingProps } from '../../../../core/hooks/useBehavioralTrackingProps.js';
import { useTooltipReducer } from '../../../core/components/overlay-tooltip/useTooltipReducer.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { A11yToolbarTabIndex } from '../../../core/types/toolbar.js';
import { useHoneycombData } from '../../hooks/use-honeycomb-data.js';
import { useHoneycombToolbarConfig } from '../../hooks/use-honeycomb-toolbar-config.js';
import { useHoneycombToolbarVisibleState } from '../../store/selectors.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export const HoneycombToolbar = () => {
  const toolbarVisible = useHoneycombToolbarVisibleState();
  const dispatch = useTooltipReducer();
  const toolbarConfig = useHoneycombToolbarConfig();
  const rawData = useHoneycombData();
  if (isUndefined(toolbarConfig)) {
    return null;
  }

  const isDownloadEnabled =
    toolbarConfig?.downloadCSV?.enabled ??
    toolbarConfig?.downloadData?.enabled ??
    false;
  const defaultToolbarPlacement = 'top-right';

  const handleMouseEnter = () => {
    dispatch({ type: 'RESET_TOOLTIP' })();
  };

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => buildAndDownloadCsv(rawData);

  const showDefaultToolbarDownloadButton =
    isDownloadEnabled && !toolbarConfig?.intents;
  const showMenuToolbarButton =
    isDownloadEnabled && !!toolbarConfig?.intents?.length;

  const initialA11yState: A11yToolbarTabIndex[] =
    showDefaultToolbarDownloadButton ? [{ download: 0 }] : [{ intent: 0 }];

  const behaviorTrackingProps = _useBehavioralTrackingProps(
    toolbarConfig ?? {},
  )[0];

  return (
    <ChartToolbarRenderer
      visible={toolbarVisible}
      collapsed={toolbarConfig.collapsed}
      draggable={true}
      placement={toolbarConfig.placement || defaultToolbarPlacement}
      initialA11yState={initialA11yState}
      onMouseEnter={handleMouseEnter}
      menuDisplayMode="never"
      isDownloadEnabled={showMenuToolbarButton}
      intents={toolbarConfig?.intents}
      handleDownloadDataToolbar={handleDownloadDataToolbar}
      removeDragHandle
      {...behaviorTrackingProps}
    >
      {showDefaultToolbarDownloadButton && <HoneycombDownloadDataButton />}
    </ChartToolbarRenderer>
  );
};

HoneycombToolbar['displayName'] = 'HoneycombToolbar';
